/* ATOMS-INVOICE-MOD-REQ-2025-11 */
class FormValidate {
  formatUppcaseAccent(input) {
    let value = input.value;
    value = value.toUpperCase();
    value = value.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    input.value = value;
  }

  formatUppcaseAccentWithN(input) {
    let value = input.value;
    value = value.toUpperCase();
    value = value.replace(/Ñ/g, "__ENIE__");
    value = value.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    value = value.replace(/__ENIE__/g, "Ñ");
    input.value = value;
  }

  onlyDigits(input) {
    let value = input.value;
    value = value.replace(/\D/g, "");
    input.value = value;
  }
};

const formValidate = new FormValidate();

